import { render } from "./NormalContainer.vue?vue&type=template&id=717e3355"
import script from "./NormalContainer.vue?vue&type=script&lang=ts"
export * from "./NormalContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script